import { useI18n } from '../i18n';

export default function About() {
  const { t } = useI18n();
  const paragraphs = t('about.paragraphs');

  return (
    <section id="about" className="bg-[#0F172A] px-6 py-24 text-[#FFFBEB]">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center">
          <div>
            <h2 className="font-['Russo_One'] text-4xl uppercase text-[#F59E0B] md:text-5xl">
              {t('about.title')}
            </h2>
          </div>
          <div className="space-y-6">
            {Array.isArray(paragraphs) &&
              paragraphs.map((p, idx) => (
                <p key={idx} className="text-lg leading-relaxed text-[#FDE68A]/90">
                  {p}
                </p>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}
